const CustomTooltip = ({
  content = "",
  containerClsNames = "",
  txtClsNames = "",
  tooltipTitle = "",
  tooltipTitleClass = "",
  arrowClsNames = "",
  component = null,
}) => {
  return (
    <div className={containerClsNames}>
      <div className={arrowClsNames}></div>
      <div className={txtClsNames}>
        <div className={tooltipTitleClass}>{tooltipTitle}</div>
        <div>{component ? component : content}</div>
      </div>
    </div>
  );
};

export default CustomTooltip;
